export function formatDecimals(number) {
    // Inserta ',' como separador de miles en cada secuencia de digitos
    const separarMiles = (digitos) => {
        let resultado = '';
        for (let i = 0; i < digitos.length; i++) {
            const restantes = digitos.length - i - 1;
            resultado += digitos[i];
            if (restantes > 0 && restantes % 3 === 0) {
                resultado += ',';
            }
        }
        return resultado;
    };
    let arr = number.toString().split('.');
    arr[0] = arr[0].replace(/\d+/g, separarMiles);
    return arr[1] ? arr.join('.') : arr[0];
};
